import React, { useEffect, useRef, useState } from 'react';
import { api, type SigningDocument } from '../api';
import { TYPE, useTheme } from '../theme';
import { Button, Card, Field, Input } from '../components/ui';

/**
 * KO2 · Admin: avtalet mellan Qvenari och markägarna (Word .docx eller PDF). Markägarna signerar
 * det under Medlemmar → Avtal och krav. En ny version ersätter den gamla; redan signerade avtal
 * ligger kvar, och markägarna ombeds signera den nya versionen.
 */
export function PlatformAgreementAdmin() {
  const T = useTheme();
  const [docs, setDocs] = useState<SigningDocument[] | null>(null);
  const [title, setTitle] = useState('Avtal mellan Qvenari och markägaren');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const ref = useRef<HTMLInputElement>(null);
  const load = () => api.platformAgreementDocuments().then(setDocs).catch(e => { setMsg(e.message); setDocs([]); });
  useEffect(() => { void load(); }, []);
  const upload = async (file: File) => {
    setBusy(true); setMsg('');
    try { await api.uploadSigningDocument({ scope: 'platform', title, file }); setMsg('Uppladdat – markägarna ser den nya versionen'); await load(); }
    catch (e: any) { setMsg(e.message); }
    setBusy(false);
    if (ref.current) ref.current.value = '';
  };
  const current = docs?.[0];
  return (
    <Card data-testid="platform-agreement-admin">
      <div style={{ ...TYPE.title, color: T.text, marginBottom: 4 }}>Markägaravtal</div>
      <div style={{ ...TYPE.small, color: T.textSub, marginBottom: 14 }}>Avtalet mellan Qvenari och markägarna. Markägaren signerar med namn och ritad signatur (BankID senare).</div>
      <div style={{ ...TYPE.small, color: T.text, marginBottom: 12 }}>
        {current ? <>Gällande: <b>{current.title}</b> ({current.fileName}, {new Date(Number(current.createdAt)).toLocaleDateString('sv-SE')})
          <button onClick={() => api.openSigningFile('document', current.id).catch(e => setMsg(e.message))} style={{ background: 'none', border: 'none', color: T.accentText, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', fontSize: 14, minHeight: 44 }}>Öppna</button></>
          : docs ? 'Inget avtal uppladdat ännu.' : 'Hämtar …'}
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <Field label="Rubrik" style={{ flex: '1 1 260px' }}><Input value={title} onChange={e => setTitle(e.target.value)} /></Field>
        <Button loading={busy} onClick={() => ref.current?.click()}>{current ? 'Ladda upp ny version' : 'Ladda upp (Word/PDF)'}</Button>
        <input ref={ref} type="file" hidden accept=".pdf,.docx" onChange={e => { const f = e.target.files?.[0]; if (f) void upload(f); }} />
      </div>
      {msg && <div role="status" style={{ ...TYPE.small, color: T.textSub, marginTop: 8 }}>{msg}</div>}
    </Card>
  );
}
